// @ts-check
// @ts-expect-error
import { getDevice } from 'framework7';

/**
 * Checks if the current platform is Cordova.
 * @returns {boolean} `true` if running in a Cordova environment, `false` otherwise.
 */
export function isDeviceCordova() {
  return getDevice().cordova;
}
